import { useState, useEffect, useMemo } from "react";
import { debounce } from "../utils/debounce";

function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		width: undefined,
		height: undefined,
	});

	const debouncedResize = useMemo(() => {
		return debounce(() => {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}, 100);
	}, []);

	useEffect(() => {
		window.addEventListener("resize", debouncedResize);

		debouncedResize();

		return () => window.removeEventListener("resize", debouncedResize);
	}, [debouncedResize]);

	return windowSize;
}

export { useWindowSize };
